<template>
  <div>
    <b-file
      ref="imageupload"
      v-model="file"
      data-test="input-img-upload-upload"
      placeholder="Choose new image"
      drop-placeholder="Drop image here..."
      accept="image/*"
      @input="imageInput"
    />

    <b-button-group
      v-if="hasPreview"
      class="mt-1 w-100"
    >
      <b-button
        data-test="btn-img-upload-upload"
        variant="outline-secondary"
        :disabled="disabled"
        @click="upload()"
      >
        Upload
      </b-button>
      <b-button
        data-test="btn-img-upload-cancel"
        variant="outline-secondary"
        :disabled="disabled"
        @click="cancel()"
      >
        Cancel
      </b-button>
    </b-button-group>

    <b-button
      v-if="!hasPreview && hasImage"
      data-test="btn-img-upload-remove-img"
      class="mt-1 w-100"
      variant="outline-secondary"
      @click="removeExistingImage"
    >
      Remove existing image
    </b-button>
  </div>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

const props = {
  // If isConfig is false, configPath should be ['path/to/node', 'key']
  configPath: {
    type: Array as PropType<string[]>,
    required: true,
  },
  // If isConfig is false, will store image link in node config instead of Config
  isConfig: {
    type: Boolean,
    default: true,
  },
}

// eslint-disable-next-line no-use-before-define
@Component<ImageUpload>({
  watch: {
    hasPreview () {
      const preview = this.$typedStore.primary.entities.images.imagePreview(this.previewConfigPath)
      this.file = preview ? preview.file : null
    },
  },
})
export default class ImageUpload extends Vue.extend({ props }) {
  file:File|null = null
  disabled = false

  get hasPreview () {
    return Boolean(this.$typedStore.primary.entities.images.imagePreview(this.previewConfigPath))
  }

  get hasImage () {
    return Boolean(this.$typedStore.primary.entities.images.imageId(this.previewConfigPath))
  }

  get previewConfigPath () {
    return [this.isConfig ? 'config' : 'node', ...this.configPath]
  }

  imageInput (file: File) {
    if (file) {
      this.$typedStore.primary.entities.images.addPreviewImage({ configPath: this.previewConfigPath, file })
    } else {
      this.$typedStore.primary.entities.images.removePreviewImage({ configPath: this.previewConfigPath })
    }
  }

  async upload () {
    this.disabled = true
    await this.$typedStore.primary.entities.images.saveImage(this.previewConfigPath)
    this.disabled = false
  }

  removeExistingImage () {
    this.$typedStore.primary.entities.images.removeExistingImage(this.previewConfigPath)
  }

  cancel () {
    this.file = null
  }
}

</script>
